export enum ExtendCurrency {
  Usd = 'USD',
  Cad = 'CAD',
}

export enum ExtendLocales {
  enUS = 'en-US',
  enCA = 'en-CA',
  frCA = 'fr-CA',
}

export enum AvatarSizes {
  Small = 'small',
  Small24 = 'small-24',
  Medium = 'medium',
  MediumLarge = 'medium-large',
  Large = 'large',
  Huge = 'huge',
  ExtraHuge = 'extra-huge',
  ExtraExtraHuge = 'extra-extra-huge',
}

export enum ImageNames {
  CardTypeRecurring = 'CardTypeRecurring',
  CardTypeStandard = 'CardTypeStandard',
  CardTypeGuest = 'CardTypeGuest',
  CardTypeRecurringGuest = 'CardTypeRecurringGuest',
  CardTypeMultiple = 'CardTypeMultiple',
  BudgetStandardActive = 'BudgetStandardActive',
  BudgetRecurringActive = 'BudgetRecurringActive',
  BudgetUnlimitedActive = 'BudgetUnlimitedActive',
  NoBudgets = 'NoBudgets',
  NoNotes = 'NoNotes',
  NoSource = 'NoSource',
  NoTransactions = 'NoTransactions',
  NoVirtualCards = 'NoVirtualCards',
  AccountsEmptyState = 'AccountsEmptyState',
  BuildingsPeople = 'BuildingsPeople',
  APIProductEmptyState = 'APIProductEmptyState',
  List = 'List',
  ListSearch = 'ListSearch',
  ListAutomation = 'ListAutomation',
  Account = 'Account',
  Accounts = 'Accounts',
  HomescreenCardAccent = 'HomescreenCardAccent',
  HomescreenAccountAccent = 'HomescreenAccountAccent',
  HomescreenOrgAccent = 'HomescreenOrgAccent',
  NoOOPE = 'NoOOPE',
  ReceiptUpload = 'ReceiptUpload',
  VirtualCard = 'VirtualCard',
  NotFound = 'NotFound',
  OrganizationInvite = 'OrganizationInvite',
  Buildings = 'Buildings',
  Profile = 'Profile',
  AddExpense = 'AddExpense',
  Transaction = 'Transaction',
  NothingToReview = 'NothingToReview',
}

export enum svgImageNames {
  NoUsers = 'NoUsers',
  NoSpend = 'NoSpend',
  NoAccountsOrBudgets = 'NoAccountsOrBudgets',
  HomescreenTopMetricsAccent = 'HomescreenTopMetricsAccent',
  ExpenseTopRight = 'ExpenseTopRight',
  BuildingsPeople = 'BuildingsPeople',
  InviteGuest = 'InviteGuest',
}
export enum SupportedBrands {
  Extend = 'extend',
  PacWest = 'pacwest',
  Corpay = 'corpay',
  Bmo = 'bmo',
  Pnc = 'pnc',
  Boc = 'boc',
  Jpm = 'jpm',
}

export enum Acknowledgements {
  OwnerAdminCardManagerMigration = 'OWNER_ADMIN_CARD_MANAGER_MIGRATION',
}

export enum CoBrands {
  Bmo = SupportedBrands.Bmo,
  Pnc = SupportedBrands.Pnc,
}

export enum UserStatus {
  NotEnrolled = 'NOT_ENROLLED',
  NotVerified = 'NOT_VERIFIED',
  PhoneNotVerified = 'PHONE_NOT_VERIFIED',
  Verified = 'VERIFIED',
  EmailVerified = 'EMAIL_VERIFIED',
}

export enum PusherEvents {
  VirtualCardCreate = 'VIRTUAL_CARD_CREATE',
  VirtualCardUpdate = 'VIRTUAL_CARD_UPDATE',
  VirtualCardBatchUpdate = 'VIRTUAL_CARD_BATCH_UPDATE',
  VirtualCardCancel = 'VIRTUAL_CARD_CANCEL',
  VirtualCardUncancel = 'VIRTUAL_CARD_UNCANCEL',
  CreditCardCreate = 'CREDIT_CARD_CREATE',
  CreditCardDelete = 'CREDIT_CARD_DELETE',
  CreditCardUpdate = 'CREDIT_CARD_UPDATE',
  UserUpdate = 'USER_UPDATE',
  SyncRequested = 'SYNC_REQUESTED',
  TransactionReportUpdate = 'TRANSACTION_REPORT_UPDATE',
  CreditCard = 'CREDIT_CARD',
  Report = 'REPORT',
  Transaction = 'TRANSACTION',
  User = 'USER',
  VirtualCard = 'VIRTUAL_CARD',
  BulkUpload = 'BULK_UPLOAD',
  Organizations = 'ORGANIZATIONS',
  OrganizationInvite = 'ORGANIZATION_INVITE',
  BulkReceiptCapture = 'BULK_RECEIPT_CAPTURE',
  BulkVirtualCardAction = 'BULK_ACTION',
  BulkVirtualCardTask = 'BULK_TASK',
  BudgetRequest = 'BUDGET_REQUEST',
  AsyncJob = 'ASYNC_JOB',
  CardFeed = 'CARD_FEED',
  SaasOrganization = 'SAAS_ORGANIZATION',

  /** For Astrada, this event means the physical account has been created and goes through a verification flow */
  PhysicalAccount = 'PHYSICAL_ACCOUNT',
}

export enum VirtualCardTemplateTypes {
  Standard = 'STANDARD',
  Recurring = 'REFILL',
  Guest = 'GUEST',
  BillPay = 'BILLPAY',
}

export enum IssuerCodes {
  Amex = 'AMEX',
  AmexCel = 'AMEXCEL',
  AmexTest = 'AMEXTEST',
  Test = 'TEST',
  Regions = 'REGIONS',
  RegionsTest = 'REGIONSTEST',
}

export enum IssuerIds {
  AmexDemo = 'iss_3IwKshsEbsp6JxlQxdEeqc',
  Amex = 'iss_3IwKshsEbsp6JxlQxdEeqc',
}

export enum AmexCardTypes {
  Corporate = 'CORPORATE',
  Business = 'BUSINESS',
}

export enum AmexCardHolderTypes {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export enum Issuers {
  Visa = 'VISA',
  Svb = 'SVB',
  Mastercard = 'MASTERCARD',
  Amex = 'AMEX',
  Comdata = 'COMDATA',
  Dataflex = 'DATAFLEX',
  AmexDemo = 'AMEXTEST',
  Bmo = 'BMO-MCIC',
  BmoDemo = 'BMOTEST',
  PacWest = 'PACWEST',
  PacWestDemo = 'PACWESTTEST',
  PacWestRetail = 'PWB-MCIC',
  PacWestRetailDemo = 'PWB-MCIC-TEST',
}

export enum RegionsIssuers {
  REGIONS = 'REGIONS',
  REGIONSTEST = 'REGIONSTEST',
}

export enum downloadOptions {
  qboForQuickBooks = 'QBO for QuickBooks',
  csv = 'CSV',
}

export enum DownloadStatus {
  Success = 'SUCCESS',
  Error = 'ERROR',
}

export enum PeopleSubSections {
  members = 'members',
  contacts = 'contacts',
  invites = 'invites',
}

export enum OrganizationRoles {
  member = 'MEMBER',
  bookkeeper = 'BOOKKEEPER',
  cardManager = 'CARD_MANAGER',
  admin = 'ADMIN',
  owner = 'OWNER',
  guest = 'GUEST',
}

export enum OrganizationActions {
  NOTHING = 'NOTHING',
  DEACTIVATE = 'DEACTIVATE',
  REASSIGN = 'REASSIGN',
}

export enum OrganizationInviteActions {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
}

export enum BookkeeperAccountVisibilityTypes {
  ALL = 'ALL',
  SELECTIVE = 'SELECTIVE',
}

export enum AuthTypes {
  auth0 = 'AUTH0',
  cognito = 'COGNITO',
}

export enum MfaTypes {
  smsMfa = 'SMS_MFA',
  softwareTokenMfa = 'SOFTWARE_TOKEN_MFA',
}

export enum MfaPreferences {
  noMfa = 'NO_MFA',
  email = 'EMAIL',
  sms = 'SMS',
}

export enum CognitoErrorMessages {
  incorrectUsernameOrPassword = 'Incorrect username or password.',
  passwordResetRequiredForTheUser = 'Password reset required for the user',
}

export enum BudgetTypes {
  recurring = 'Recurring',
  unlimited = 'Unlimited',
  standard = 'Standard',
}

export enum VirtualCardTypes {
  recurring = 'RECURRING',
  standard = 'STANDARD',
  guestAccess = 'GUEST',
  recurringGuest = 'GUEST_RECURRING',
  bulk = 'BULK',
  billPay = 'VENDOR',
  decliningBalance = 'DECLINING_BALANCE',
  issuerCycle = 'ISSUER_CYCLE',
}

export enum IssuerSchemaFilterFields {
  cardNumber = 'cardNumber',
  expires = 'expires',
  cvc = 'cvc',
}

export enum IncidentComponentNames {
  extend = 'Extend',
}

export enum VirtualCardFilterStatus {
  active = 'active',
  inactive = 'inactive',
  pending = 'pending',
  closed = 'closed',
}

export enum OrganizationConnectedPlatform {
  NETSUITE = 'NETSUITE',
  QUICKBOOKS_ONLINE = 'QUICKBOOKS_ONLINE',
  QUICKBOOKS_DESKTOP = 'QUICKBOOKS_DESKTOP',
  QUICKBOOKS_ONLINE_SANDBOX = 'QUICKBOOKS_ONLINE_SANDBOX',
  XERO = 'XERO',
  SAGE_INTACCT = 'SAGE_INTACCT',
  DYNAMICS_BC = 'DYNAMICS_BC',
  AMEX = 'AMEX',
  SANDBOX = 'SANDBOX',
  UNKNOWN = 'UNKNOWN',
}

export enum OrganizationIntegrationStatus {
  ACTIVE = 'ACTIVE',
  WAITING_FOR_INITIAL_PULL = 'WAITING_FOR_INITIAL_PULL',
  WAITING_TO_SYNC = 'WAITING_TO_SYNC',
  PENDING_CONFIGURATION = 'PENDING_CONFIGURATION',
  LACK_PERMISSIONS = 'LACK_PERMISSIONS',
  CONNECTED_TO_OTHER_SERVICE = 'CONNECTED_TO_OTHER_SERVICE',
  UNLINKED = 'UNLINKED',
  DEAUTHORIZED = 'DEAUTHORIZED',
}

export enum OrgIntegrations {
  none = 'NONE',
  netSuite = 'NETSUITE',
  quickbooks = 'QUICKBOOKS',
  quickbooksOnline = 'QUICKBOOKS_ONLINE',
  quickbooksSandbox = 'QUICKBOOKS_ONLINE_SANDBOX',
  quickbooksDesktop = 'QUICKBOOKS_DESKTOP',
  xero = 'XERO',
  sageIntacct = 'SAGE_INTACCT',
  microsoftDynamics = 'DYNAMICS_BC',
}

export enum AmexCardTypeFields {
  corporate = 'corporate',
  business = 'business',
  not_sure = 'not_sure',
}

export enum VirtualCardDeactivatingInIncrements {
  // values subject to change
  in7Days = '7',
  in14Days = '14',
  in30Days = '30',
}

export enum ReferralSources {
  bankCreditCardRep = 'Bank / credit card representative',
  friendColleague = 'Friend / colleague',
  searchEngine = 'Search engine (Google, etc.)',
  softwareReviewSite = 'Software review site',
  linkedin = 'LinkedIn',
}

export enum TransactionFilterOptions {
  Date,
  TransactionDateRange,
  TransactionAmountRange,
  TransactionStatus,
  TransactionOrigin,
  ExpenseCategoryStatus,
  ExpenseCategoryLabels,
  ReceiptStatus,
  TransactionSyncStatus,
  ReceiptSyncStatus,
  CardUser,
  Departments,
  Account,
  MerchantCategory,
  ReviewStatus,
  Search,
}

export enum OrgExpenseReportType {
  Account = 'ACCOUNT',
}

export enum OrgExpenseReportCycleType {
  DayOfMonth = 'DAY_OF_MONTH',
  Monthly = 'MONTHLY',
}

export enum MfaDeliveryMedium {
  Email = 'EMAIL',
  SMS = 'SMS',
}

export enum AsyncJobType {
  ExpenseDataUpdate = 'EXPENSE_DATA_UPDATE',
  TransactionReviewStatusUpdate = 'TRANSACTION_REVIEW_STATUS_UPDATE',
}

export enum HidableToastNames {
  BulkTransactionUpdate = 'BULK_TRANSACTION_UPDATE',
  BulkVirtualCardAction = 'BULK_VIRTUAL_CARD_ACTION',
}
